import React, { useEffect,useState } from 'react'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import { adminHeaderApi } from '../../../utils/AdminDashApi/HeaderApi'
import { BiBell } from 'react-icons/bi'
import {Row,Col,Modal} from 'react-bootstrap'
import '../../../sassFiles/sassPages/admindashboard/bill/billlallstyle.scss'
import { billCollectionApi, prevCollectionhistoryApi, searchtableApi } from '../../../utils/AdminDashApi/Bill/BillApi'
import { optionsPeriod, optionsbilltype, optionsrcvtype, optionsremark } from '../../Helper'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { HighlightRowText } from '../../../pages/adminDashboard/Bill/subComponents/HighlightRowText'
import axios from 'axios';
const BillCancelComp = () => {

    const [billnumber,setbillnumber] = useState("")
    const [id,setid] = useState("")
    const [stuname,setstuname] = useState("")
    const [myclass,setclass] = useState("")
    const [section,setsection] = useState("")
    const [shift,setshift] = useState("")
    const [totalamount,settotalamount] = useState("")
    const [cancelreason,setcancelreason] = useState("")

    const [labelbillnum,setlabelbillnum] = useState("")
    const [labelid,setlabelid] = useState("")
    const [labelstuname,setlabelstuname] = useState("")
    const [labelclass,setlabelclass] = useState("")
    const [labelsection,setlabelsection] = useState("")
    const [labelshift,setlabelshift] = useState("")
    const [labelcancelreason,setlabelcancelreason] = useState("")

    const [borderbillnumber,setborderbillnumber] = useState("")
    const [borderid,setborderid] = useState("")
    const [borderstuname,setborderstuname] = useState("")
    const [borderclass,setborderclass] = useState("")
    const [bordersection,setbordersection] = useState("")
    const [bordershift,setbordershift] = useState("")
    const [bordercancelreason,setbordercancelreason] = useState("")

    const [searchkey,setsearchkey] = useState("")
    const [screenSize, getDimension] = useState({
        dynamicWidth: window.innerWidth,
        dynamicHeight: window.innerHeight
      });
      const setDimension = () => {
        getDimension({
          dynamicWidth: window.innerWidth,
          dynamicHeight: window.innerHeight
        })
      }
      
      useEffect(() => {
        window.addEventListener('resize', setDimension);
        
        return(() => {
            window.removeEventListener('resize', setDimension);
            
        })
      }, [screenSize])

      const [searchpopulatedata,setsearchpopulatedata] = useState({
        headerid:"",
        id:""
    })
    const handleRowClick=(myitem)=>{
        console.log(myitem.headerid)
        setsearchpopulatedata({...searchpopulatedata,["headerid"]:myitem.headerid})
        console.log("ami clicked")
        setsearchkey("")

    }
    const handleInputSearch = (e)=>{
        setsearchkey(e.target.value)

    }
    const handleSearchButton= async ()=>{
        console.log(searchkey)
        setbillnumber("")
        await SearchBillInfo(searchkey)
    }
    const headers = {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Methods": "*",
    }
    async function SearchBillInfo(SearchKeyWord) {
        console.log(SearchKeyWord)
        try {
          axios.get(`https://localhost:7229/api/Bill/GetBillCancleInfo?BillNumber=${SearchKeyWord}`, headers)
          .then(function (response) {
            console.log(response.data)
            //setempSearchInforesponse(response.data);
            if(response.data.classId !== null){
                setbillnumber(SearchKeyWord)
                setid(response.data.studentId)
                setstuname(response.data.studentName)
                setclass(response.data.class)
                setsection(response.data.section)
                setshift(response.data.shift)
                settotalamount(response.data.totalAmount)
                setcancelreason("");
            }
            else{
                console.log(response.data)
                toast.error("Bill not found", {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    })
            }
            
          });
        } catch (err) {
          if (err.response) {
            console.error(err.response.data);
            console.log(err.response.status);
            console.log(err.response.header);
          } else {
            console.error(`Error: ${err.message}`);
          }
        }
    }
    const notification = {
        notification:true
    }

    const handlecancel= async (e)=>{
        e.preventDefault()
        if(!cancelreason && cancelreason==""){
            setlabelcancelreason("cancel reason required")
            setbordercancelreason(true)
        }else{
            setlabelcancelreason("")
            setbordercancelreason(false)
            await CancelBillAction()
        }
    }
    async function Clear(){
        setbillnumber("")
        setid("")
        setstuname("")
        setclass("")
        setsection("")
        setshift("")
        settotalamount("")
        setcancelreason("");
    }
    async function CancelBillAction(data) {
        console.log(data);
        try {
          axios
            .post(
              `https://localhost:7229/api/Bill/BillCancel?BillNumber=${billnumber}&BillCancelReason=${cancelreason}`,
              headers
            )
            .then(function (response) {
              console.log(response.data)
              if(response.data > 0){
                toast.success("Bill canceled Successfully", {
                  position: "top-center",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
                  });
                 Clear();
              }
              else{
                toast.error("Bill not canceled", {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    })
                    Clear();
              }
            });
        } catch (err) {
          if (err.response) {
            console.error(err.response.data);
            console.log(err.response.status);
            console.log(err.response.header);
          } else {
            console.error(`Error: ${err.message}`);
          }
        }
      }
  return (
    <>
         <div className="f-flex flexvaluecomp">
            <SidebarOfAdash/>

            <div className="contentpartwidthwrapper" style={screenSize.dynamicHeight<925 ? {marginBottom:"75px"}:{}}>
                <div className="headerofadash billpart">
                <div className="left">
                    <div className="leftsidesearch">
                        <input type="text" value={searchkey} onChange={handleInputSearch} name="searchword" placeholder='Search Bill Number'/>
                        <span onClick={handleSearchButton}>
                            <img src="./assets/images/dashboards/adminDashboard/bill/searchbutton.png" alt="" />
                        </span>
                    </div>

                </div>
                <div className="right">
                    {
                        notification.notification==true?
                        <div className="belldiv">
                            <BiBell/>
                        </div>
                        :
                        <BiBell/>
                     }
                    <div className="displaypic">
                        <img src="./assets/images/dashboards/adminDashboard/header/DP.png" alt="" />
                    </div>
                    <div className="nameandid">
                        <h5>{adminHeaderApi.name}</h5>
                        <p>ID {adminHeaderApi.id}</p>
                    </div>
                </div>
            </div>

            <div className=" contentflexvalue billcontent billupdate w742">
                <Row>
                    <Col lg={12} className="pd15">  
                        <div className="smallheader d-flex">
                            <h4>Bill Cancel</h4>
                        </div>
                                <div className="billbox small morph">
                   

                            <div className="threedivide">
                                <div className="commonthertythree">
                                        <div className=" h35">
                                        <div className="left">
                                            <p>Bill Number</p>
                                        </div>
                                        <div className="right">
                                            <div className="inputgap h35">
                                            <input type="text" style={borderbillnumber ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} value={billnumber} onChange={(e)=>setbillnumber(e.target.value)}/>
                                           
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="commonthertythree">
                                        <div className=" h35">
                                        <div className="left">
                                            <p>Student ID</p>
                                        </div>
                                        <div className="right">
                                        <div className="inputgap h35">
                                            <input style={{borderColor:"#ebebeb"}}  type="text" value={id} onChange={(e)=>setid(e.target.value)}/>
                                          
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="commonthertythree">
                                        <div className="">
                                        <div className="left w130">
                                            <p>Student Name</p>
                                        </div>
                                        <div className="right">
                                        <div className="inputgap h35">
                                            <input style={{borderColor:"#ebebeb"}}  type="text" value={stuname} onChange={(e)=>setstuname(e.target.value)}/>
                                            
                                        </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                                <div className="threedivide">

                                <div className="commonthertythree">
                                        <div className="">
                                        <div className="left w130">
                                            <p>Class</p>
                                        </div>
                                        <div className="right">
                                        <div className="inputgap h35">
                                            <input style={{borderColor:"#ebebeb"}}  type="text" value={myclass} onChange={(e)=>setclass(e.target.value)}/>
                                            
                                        </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="commonthertythree">
                                        <div className="">
                                        <div className="left w130">
                                            <p>Section</p>
                                        </div>
                                        <div className="right">
                                        <div className="inputgap h35">
                                            <input style={{borderColor:"#ebebeb"}}  type="text" value={section} onChange={(e)=>setsection(e.target.value)}/>
                                            
                                        </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="commonthertythree">
                                        <div className="">
                                        <div className="left w130">
                                            <p>Shift</p>
                                        </div>
                                        <div className="right">
                                        <div className="inputgap h35">
                                            <input style={{borderColor:"#ebebeb"}}  type="text" value={shift} onChange={(e)=>setshift(e.target.value)}/>
                                            
                                        </div>
                                        </div>

                                    </div>
                                </div>
                                </div>
                                <div className="threedivide">
                                <div className="commonthertythree">
                                        <div className="">
                                        <div className="left w130">
                                            <p>total Amount</p>
                                        </div>
                                        <div className="right">
                                        <div className="inputgap h35">
                                            <input style={{borderColor:"#ebebeb"}}  type="text" value={totalamount} onChange={(e)=>settotalamount(e.target.value)}/>
                                            
                                        </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="commonthertythree commonsixtysix">
                                        <div className="">
                                        <div className="left w130">
                                            <p>Cancel Reason</p>
                                        </div>
                                        <div className="right">
                                        <div className="inputgap h35">
                                            <input type="text" style={bordercancelreason ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} value={cancelreason} onChange={(e)=>setcancelreason(e.target.value)}/>
                                            <label>{labelcancelreason}</label>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                </div>
                                <div className="text-center cancelbutton">
                                    <button onClick={handlecancel}>Cancel</button>
                                
                                </div>
                                </div>
                      

                    
                    </Col>
                    
               
                 
                </Row>
                <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
            />
                
            </div>
            </div>
            </div>
    </>
  )
}

export default BillCancelComp